import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';

import { NewRolePage } from '~/features/workspace/roles/new-role-page';

/** New role: OS first (web-redesign-10 phase 6), or `?by=hand` for the two columns set up by hand on the same draft (web-redesign-03 phase 2.3). */
const search = z.object({ by: z.enum(['hand']).optional() });

export const Route = createFileRoute('/_app/business/roles/new')({ validateSearch: search, component: NewRolePage });
